import { Fragment, FC } from "react";

const Hospital: FC<{ color: string }> = ({ color = "white" }) => {
  return (
    <Fragment>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1998 27.4667V19.1333L6.99984 23.3L5.1665 20.2L12.3998 16L5.19984 11.8333L6.99984 8.73333L14.1998 12.9V4.53333H17.7998V12.9L24.9998 8.73333L26.7998 11.8333L19.5998 16L26.8332 20.2L24.9998 23.3L17.7998 19.1333V27.4667H14.1998Z"
          fill={color}
        />
      </svg>
    </Fragment>
  );
};

export default Hospital;
